// extracted by mini-css-extract-plugin
module.exports = {"mobileErrorModal":"_2MEsZ","desktopErrorModal":"_1Xk9k"};